import { useBrandsSearchQuery } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/__internal__/useBrandsSearchQuery";
import { logAssert } from "@faire/web/common/logging";
import { IPaginationData } from "@faire/web-api--source/indigofair/data/IPaginationData";

export const useLoggedOutSuppliersPagePaginationData = ():
  | IPaginationData
  | undefined => {
  const brandsSearchQueryData = useBrandsSearchQuery().data;

  if (!brandsSearchQueryData) {
    return;
  }

  logAssert(
    !!brandsSearchQueryData.paginationData,
    "Logged-out Suppliers page pagination data not sent"
  );

  return brandsSearchQueryData.paginationData;
};
